import React, { useEffect, useState } from 'react';
import styles from './Navbar.module.scss';
import navbarItems from './navbar-items.json';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useScrollPosition from '../../hooks/useScrollPosition';
import useWindowDimensions from '../../hooks/useWindowDimesions';
import { FontAwesomeIcon, Props } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Button, Drawer } from '@mui/material';

type NavItemProps = {
  id?: string;
  pogrId?: string;
  item: {
    title: string;
    route?: string;
  };
  pathname?: string;
};

const ID_PREFIX = "navbar";

const NavItem = ({ id, pogrId, item, pathname = "" }: NavItemProps) => {
  const navigate = useNavigate();
  const firstPath = pathname.split("/")[1];
  const match = item.route === `/${firstPath}`;

  const handleClick = () => {
    item.route && navigate(item.route);
  };

  return (
    <div
      id={`${id}-container`}
      data-pogr-id={`${pogrId || id}-container`}
      className={`${styles.itemContainer} ${match && styles.active}`}
      onClick={handleClick}
    >
      <h4 id={`${id}-title`} data-pogr-id={`${pogrId || id}-title`}>
        {item.title}
      </h4>
    </div>
  );
};



function Navbar({}: Props) {
  const scrollPosition = useScrollPosition();
  const { isTablet } = useWindowDimensions();
  const location = useLocation();
  const [dark, setDark] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (
      scrollPosition > 120 ||
      location.pathname.includes("/tos") ||
      location.pathname.includes("/privacy")
    ) {
      setDark(true);
    } else setDark(false);
  }, [scrollPosition]);

  if (isTablet) {
    return (
      <div
        id={`${ID_PREFIX}-table-container`}
        data-pogr-id={`${ID_PREFIX}-table-container`}
        className={`${styles.container} ${
          dark ? styles.darkmode : styles.lightmode
        }`}
      >
        <div
          id={`${ID_PREFIX}-table-content`}
          data-pogr-id={`${ID_PREFIX}-table-content`}
          className={styles.content}
        >
          <div
            id={`${ID_PREFIX}-brand-container`}
            data-pogr-id={`${ID_PREFIX}-brand-container`}
            className={styles.brandContainer}
          >
            <img
              id={`${ID_PREFIX}-brand-image`}
              data-pogr-id={`${ID_PREFIX}-brand-image`}
              src="/static/brand/brand-horizontal.png"
              alt="brand"
            />
          </div>
        
        </div>
      
      </div>
    );
  }

  return (
    <div
      id={`${ID_PREFIX}-container`}
      data-pogr-id={`${ID_PREFIX}-container`}
      className={`${styles.container} ${
        dark ? styles.darkmode : styles.lightmode
      }`}
    >
      <div
        id={`${ID_PREFIX}-content`}
        data-pogr-id={`${ID_PREFIX}-content`}
        className={styles.content}
      >
        <Link to={"/"}>
          <div
            id={`${ID_PREFIX}-brand-container`}
            data-pogr-id={`${ID_PREFIX}-brand-container`}
            className={styles.brandContainer}
          >
            <img
              id={`${ID_PREFIX}-brand-image`}
              data-pogr-id={`${ID_PREFIX}-brand-image`}
              src="/static/brand/brand-horizontal.png"
              alt="brand"
            />
          </div>
        </Link>
     
      </div>
    </div>
  );
}

export default Navbar;
